/** Strip non-digits and cap at 8 digits for MMDDYYYY entry. */
export function digitsOnlyMmDdYyyy(raw: string): string {
  return raw.replace(/\D/g, '').slice(0, 8)
}

/** Format digit input as MM/DD/YYYY while typing (e.g. 08121980 → 08/12/1980). */
export function formatMmDdYyyyInput(raw: string): string {
  const digits = digitsOnlyMmDdYyyy(raw)
  if (digits.length <= 2) return digits
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`
}

/** Parse MM/DD/YYYY or MMDDYYYY to ISO YYYY-MM-DD; returns null when invalid. */
export function parseMmDdYyyyToIso(value: string): string | null {
  const digits = digitsOnlyMmDdYyyy(value)
  if (digits.length !== 8) return null
  const month = Number(digits.slice(0, 2))
  const day = Number(digits.slice(2, 4))
  const year = Number(digits.slice(4, 8))
  if (month < 1 || month > 12 || day < 1 || day > 31 || year < 1900) return null
  const iso = `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
  const parsed = new Date(`${iso}T00:00:00`)
  if (Number.isNaN(parsed.getTime())) return null
  if (parsed.getFullYear() !== year || parsed.getMonth() + 1 !== month || parsed.getDate() !== day) {
    return null
  }
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  if (parsed > today) return null
  return iso
}
